import React from 'react';
import { Snowflakes } from './components/Snowflakes';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gradient-to-br from-navy via-navy-light to-navy font-sans text-frost selection:bg-ice/30 selection:text-white relative" data-id="element-0">
      {/* Global Snowflake Overlay */}
      <Snowflakes data-id="element-1" />

      {/* Main Content */}
      <div className="relative z-10 flex flex-col min-h-screen" data-id="element-2">
        <Navbar data-id="element-3" />

        <main className="flex-grow" data-id="element-4">
          <Hero data-id="element-5" />
          <Problems data-id="element-6" />
          <Features data-id="element-7" />
          <Testimonials data-id="element-8" />
          <Pricing data-id="element-9" />
        </main>

        <Footer data-id="element-10" />
      </div>
    </div>;
}